import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableColspanPagination',
  standalone: false,
})
export class TableColspanPaginationPipe implements PipeTransform {
  transform(items: { colspan: number }[], startIndex: number, length: number) {
    if (!items || items.length === 0) {
      return items;
    }

    const newItems = [];

    let colCount = 0;
    let colStartIndex = 0;
    while (colCount < startIndex) {
      const item = items[colStartIndex];
      colStartIndex++;
      colCount += item.colspan;
    }
    if (colCount > startIndex) {
      colStartIndex--;
    }

    colCount = 0;
    let i = colStartIndex;
    while (colCount < length && i < items.length) {
      const item = items[i];
      newItems.push(item);
      i++;
      colCount += item.colspan;
    }

    return newItems;
  }
}
